import { Destination } from "common/router/types";

import EmptyResults from "./EmptyResults";
import Button from "../buttons/Button";

type NoResultsProps = {
  header?: string;
  description?: string;
  button?: string | React.ReactNode;
  dest?: Destination;
  alt?: string;
  image?: string;
};

const NoResults = (props: NoResultsProps) => {
  const {
    header = "No results found",
    description = "",
    button,
    dest,
    alt = "No Results",
    image,
  } = props;

  return (
    <EmptyResults>
      <EmptyResults.Image src={image} alt={alt} />
      <EmptyResults.Content>
        <EmptyResults.Header>{header}</EmptyResults.Header>
        <EmptyResults.Text>{description}</EmptyResults.Text>
      </EmptyResults.Content>
      {!!(button && dest) && (
        <EmptyResults.Body>
          {typeof button === "string" ? <Button dest={dest}>{button}</Button> : button}
        </EmptyResults.Body>
      )}
    </EmptyResults>
  );
};

export default NoResults;
